import { ValidationErrors } from 'final-form';
import { IPath } from '@qover/domain';
import { DraftProps } from './Draft';

export class Path implements IPath {
  buttonTitle?: React.ReactElement;
  fetchTerms?: boolean;
  nextPath?: string;
  path: string;
  redirectWithDraftId?: boolean;
  remarketing?: string;
  showFaq?: boolean;
  showFooter?: boolean;
  showLegalMentions?: boolean;
  validate?: (
    props: DraftProps,
  ) => ValidationErrors | Promise<ValidationErrors> | undefined;

  constructor({
    buttonTitle,
    fetchTerms = true,
    nextPath,
    path,
    redirectWithDraftId = true,
    remarketing,
    showFaq = true,
    showFooter = true,
    showLegalMentions = true,
    validate = (props: DraftProps) => undefined,
  }: Path) {
    this.buttonTitle = buttonTitle;
    this.fetchTerms = fetchTerms;
    this.nextPath = nextPath;
    this.path = path;
    this.redirectWithDraftId = redirectWithDraftId;
    this.remarketing = remarketing;
    this.showFaq = showFaq;
    this.showFooter = showFooter;
    this.showLegalMentions = showLegalMentions;
    this.validate = validate;
  }
}

export default class Step {
  initialPath: string;
  paths: Path[];

  constructor({ initialPath, paths }: Step) {
    this.initialPath = initialPath;
    this.paths = paths;
  }
}
